import axios from "@/util/axios";
export default {
    loadRelateProductList: function (workspaceId) {
        workspaceId
        return axios.get(`/api/workspace/productList`);
    },
    loadUserProductList: function (workspaceId) {
        workspaceId
        return axios.get(`/api/user/myBkProject`);
    },
    submitRelateProduct: function (relateData) {
        return axios.post(`/api/productRelation/add`, relateData);
    },
    deleteRelateProduct: function (relationIdData) {
        return axios.post(`/api/productRelation/delete`, relationIdData);
    },
}